import * as Sentry from '@sentry/browser'
import type React from 'react'

export function reportError (error: Error, errorInfo?: React.ErrorInfo) {
  Sentry.captureException(error, { extra: { componentStack: errorInfo?.componentStack } })
}
